import { DynamicField } from './dynamic-field.model';

export class DynamicFormDropDown extends DynamicField {
  override controlType = 'dropdown';
  override options: string[] = [];

  constructor(options: { [x in string]: any } = {}) {
    super(options);
    this.options = options['options'] || [];
  }

  override getAttributePayloadForCk(): { attributeKey: string; value: string }[] {
    const payloadDefault = super.getAttributePayloadForCk();
    payloadDefault.push({
      attributeKey: 'metadata',
      value: this.options ? this.options.join('||') : '',
    });
    return payloadDefault;
  }
}
